import moment from 'moment'
import { cpf as CPF, cnpj as CNPJ } from 'cpf-cnpj-validator'

export const removeAccentuation = (word) => {
  let text = word.toLowerCase()
  text = text.replace(new RegExp('[ÁÀÂÃ]', 'gi'), 'a')
  text = text.replace(new RegExp('[ÉÈÊ]', 'gi'), 'e')
  text = text.replace(new RegExp('[ÍÌÎ]', 'gi'), 'i')
  text = text.replace(new RegExp('[ÓÒÔÕ]', 'gi'), 'o')
  text = text.replace(new RegExp('[ÚÙÛ]', 'gi'), 'u')
  text = text.replace(new RegExp('[Ç]', 'gi'), 'c')
  return text.charAt(0).toUpperCase() + text.slice(1)
}

export const formatHash = (hash) => hash && hash.replace(/\W/g, '')

export const getAlphanumericCharacters = (value) => String(value || '').replace(/[^a-zA-Z0-9]/g, '')

export const formatCEP = (cep) => {
  if (typeof cep === 'string' && cep.trim() !== '') {
    cep = cep.replace(/\D/g, '')

    cep = cep.replace(/^(\d{2})(\d{3})(\d{3})$/, '$1.$2-$3')

    return cep
  }
  return cep
}

export const cpfCnpjMask = (value) => {
  const document = CNPJ.strip(String(value || ''))
  const isCpfCandidate = document.length <= 11 && document.split('').every((char) => char >= '0' && char <= '9')

  if (!document) {
    return ''
  }

  return isCpfCandidate ? CPF.format(document) : CNPJ.format(document)
}

export const vehiclePlateFormat = (plate) => plate && plate.replace(/\W/g, '').toUpperCase()

export const plateFormatter = (plate) => {
  const p = String(plate).replace(/\W/g, '')
  const newPlate = p.substr(0, 3).toUpperCase().concat('-').concat(p.substr(3))
  return newPlate
}

export const getTimeElapsed = (createdDate, noMinutes) => {
  const now = moment()
  const diff = moment.duration(now.diff(moment(createdDate, 'DD/MM/YYYY HH:mm:ss')))

  const elapsedDays = Math.floor(diff.asDays())

  let elapsedHours = parseInt(diff.asHours(), 10)
  elapsedHours -= elapsedDays * 24

  let elapsedMinutes = parseInt(diff.asMinutes(), 10)
  elapsedMinutes -= elapsedDays * 24 * 60 + elapsedHours * 60

  let finalElapse = ''

  if (elapsedDays > 0) {
    if (elapsedDays === 1) {
      finalElapse = finalElapse.concat(`${elapsedDays} dia `)
    } else {
      finalElapse = finalElapse.concat(`${elapsedDays} dias `)
    }
  }
  if (elapsedHours > 0) {
    if (finalElapse.length) {
      finalElapse = finalElapse.concat('e ')
    }
    if (elapsedHours === 1) {
      finalElapse = finalElapse.concat(`${elapsedHours} hora `)
    } else {
      finalElapse = finalElapse.concat(`${elapsedHours} horas `)
    }
  }

  if (finalElapse && noMinutes) {
    return finalElapse
  }

  if (elapsedMinutes > 0 && !finalElapse.length) {
    if (elapsedMinutes === 1) {
      finalElapse = finalElapse.concat(` ${elapsedMinutes} minuto`)
    } else {
      finalElapse = finalElapse.concat(` ${elapsedMinutes} minutos`)
    }
  } else if (elapsedMinutes === 0) {
    finalElapse = finalElapse.concat(` ${elapsedMinutes} minuto`)
  }
  return finalElapse
}

export const getDeliveryId = (pathname) => {
  const regex = /\/delivery\/(\d+)/
  const match = pathname.match(regex)

  return match ? match[1] : null
}

export const documentFormatter = (document) => {
  if (!document) return ''
  if (CNPJ.isValid(document)) return CNPJ.format(document)
  if (CPF.isValid(document)) return CPF.format(document)
}

export function addSpaceAfterComma(str) {
  if (!str) return ''
  return str.replace(/,(?!\s|$)/g, ', ')
}
